__turbopack_context__.v({
  "className": "inter_5a2e5239-module__eaiQJq__className",
});
